import React from 'react'
import axios from 'axios'
import classnames from 'classnames'
import Paper from '@material-ui/core/Paper'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import { fragCareer } from '../utils/fragments'
import { mapCareers, mapMetaData } from '../utils/mapper'
import { withStyles } from '@material-ui/core/styles'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import styles from '../styles/site'

import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Footer from '../components/footer'
import InlineVideo from '../components/video/inline'

import map from '../img/icons/map.svg'
import time from '../img/icons/time.svg'
import info from '../img/icons/info.svg'

import { API } from '../utils/constants'

class CareersPage extends React.Component {
  state = {
    position: '12',
    open: false,
    filters: [
      {
        type: 'location',
        filters: [
          { key: 0, label: 'UK', selected: true },
          { key: 1, label: 'India', selected: true },
        ],
      },
      {
        type: 'type',
        filters: [
          { key: 0, label: 'Permanent', selected: true },
          { key: 1, label: 'Partial', selected: true },
        ],
      },
    ],
    formdata: {
      name: null,
      email: null,
      mobile: null,
    },
  }

  onChange = e => {
    let formdata = this.state.formdata
    formdata[e.target.id] = e.target.value
    this.setState({ formdata: formdata })
  }

  toggleForm = position => {
    this.setState({
      position: position,
      open: !this.state.open,
    })
  }

  submitForm = (position) => {

    let formdata = this.state.formdata

    axios.post(API.enquiry, {
      mtype: 'Career',
      template: 'career',
      name: formdata.name,
      email: formdata.email,
      mobile: formdata.mobile,
      position: position
    }).then((response) => {
      this.toggleForm()
      toast.success("Your enquiry has been sent, thanks.");
    })
  }

  remove = (type, selected) => {
    let filters = [...this.state.filters]
    let filterType = filters.find(f => {
      return f.type === type
    })
    let filter = filterType.filters.find(f => {
      return f.key === selected.key
    })
    filter.selected = false

    this.setState({ filters: filters })
  }

  isShown = career => {
    let filters = [...this.state.filters]
    let show = true
    filters.forEach(type => {
      type.filters.forEach(filter => {
        if (!filter.selected) {
          return (show =
            career.filter_location === filter.label ||
            career.filter_type === filter.label
              ? false
              : true)
        }
      })
    })

    return show
  }

  reset = () => {
    let filters = [...this.state.filters]
    filters.forEach(type => {
      type.filters.forEach(filter => {
        filter.selected = true
      })
    })

    this.setState({ filters: filters })
  }

  render() {
    const { classes, toggleForm } = this.props
    const metadata = mapMetaData(this.props.data.careers)
    const careers = mapCareers(this.props.data.careers)
    const { open, position, formdata } = this.state

    return (
      <div>
        <ToastContainer />
        <MetaData data={metadata} />
        <Banner uid="careers" title={careers.title} subtitle={careers.subtitle} />
        <InlineVideo urls={careers.video.urls} poster={careers.video.poster} />
        <Filter
          filters={this.state.filters}
          remove={this.remove}
          reset={this.reset}
        />
        <CareerList
          careers={careers}
          open={open}
          toggleForm={this.toggleForm}
          submitForm={this.submitForm}
          isShown={this.isShown}
          position={position}
          formdata={formdata}
          onChange={this.onChange}
        />
        <Footer policies={this.props.data.policies.edges}/>
      </div>
    )
  }
}

const Filter = withStyles(styles)(props => {
  const { classes, filters, remove, reset } = props
  return (
    <div className={classes.contents}>
      <div className={classes.careersFilter}>
        <ExpansionPanel>
          <ExpansionPanelSummary>
            <Grid container spacing={40}>
              <Grid item xs={12}>
                <Typography>Filter</Typography>
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {filters.map((data, i) => {
              return (
                <div key={i}>
                  <Grid container spacing={40}>
                    <Grid
                      item
                      className={classes.careerFilter}
                    >
                      {
                        data.filters.map(item => (
                          item.selected &&
                            <Chip
                              key={item.key}
                              label={item.label}
                              onDelete={() => remove(data.type, item)}
                            />
                        ))
                      }
                    </Grid>
                  </Grid>
                </div>
              )
            })}
              <div
                className={classes.careerFilterReset}
                onClick={() => reset()}
              >
                <Typography style={{ float: 'right' }}>
                  Reset
                </Typography>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  )
})

const CareerList = withStyles(styles)(props => {
  const {
    classes,
    careers,
    toggleForm,
    submitForm,
    open,
    position,
    isShown,
    formdata,
    onChange,
  } = props

  return (
    <div className={classes.careers}>
      <div className={classes.contents}>
        {careers.list.map((items, index) => {
          return items.map((career, i) => {
            return (
              isShown(career) && (
                <Paper className={classes.careerPaper} key={i}>
                  <Career
                    career={career}
                    open={open}
                    toggleForm={toggleForm}
                    submitForm={submitForm}
                    position={position}
                    formdata={formdata}
                    onChange={onChange}
                  />
                </Paper>
              )
            )
          })
        })}
      </div>
    </div>
  )
})

const Career = withStyles(styles)(props => {
  const {
    classes,
    career,
    open,
    toggleForm,
    submitForm,
    position,
    formdata,
    onChange,
  } = props
  return (
    <div className={classes.career}>
      <Grid container spacing={40}>
        <Grid item xs={12}>
          <Typography variant="headline">{career.role.text}</Typography>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={24}
        className={classes.careerInfo}
        alignItems={'center'}
        direction={'row'}
        justify={'flex-start'}
      >
        <Grid item>
          <Typography>
            <img src={map} className={classes.careersIcon} alt="#" />
            {career.filter_location}
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            <img src={time} className={classes.careersIcon} alt="#" />
            {career.filter_type}
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            <img src={info} className={classes.careersIcon} alt="#" />
            {career.contact.text}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={40}>
        <Grid item xs={12}>
          <Typography>{career.description.text}</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={40}>
        <Grid item xs={12}>
          <div
            dangerouslySetInnerHTML={{ __html: career.details.html }}
            className={classes.careerDetails}
          />
        </Grid>
      </Grid>

      <Grid container spacing={40}>
        {position === career.uid && (
          <Grid container spacing={40}>
            <Grid item xs>
              <div>
                <form
                  className={classes.careerForm}
                  noValidate
                  autoComplete="off"
                >
                  <input type="hidden" value={career.uid} />
                  <Typography>
                    <TextField
                      id="name"
                      label="Name"
                      className={classes.textField}
                      margin="normal"
                      value={formdata.name}
                      onChange={e => onChange(e)}
                    />
                    <TextField
                      id="email"
                      label="Email"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={formdata.email}
                      onChange={e => onChange(e)}
                    />
                    <TextField
                      id="mobile"
                      label="Mobile"
                      className={classes.textField}
                      margin="normal"
                      value={formdata.mobile}
                      onChange={e => onChange(e)}
                      />
                  </Typography>
                </form>
              </div>
            </Grid>
          </Grid>
        )}
        <Grid item>
          {position !== career.uid ? (
            <Button
              size={'small'}
              variant={'raised'}
              onClick={() => toggleForm(career.uid)}
              className={classes.careersApply}
            >
              Apply
            </Button>
          ) : (
            <Button
              size={'small'}
              variant={'raised'}
              onClick={() => submitForm(career.uid)}
              className={classes.careersSubmit}
            >
              Submit
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  )
})

export default withStyles(styles)(CareersPage)

export const query = graphql`
  query careersQuery {
    careers: prismicCtCareers {
      ...careers
    }

    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {
              
              text
            }
            
            
          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/careers.js